import React from "react";
var __jsx = React.createElement;
import stl from "./Button.module.css";
var Button = function Button(_ref) {
  var children = _ref.children,
    onClick = _ref.onClick,
    className = _ref.className,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? null : _ref$type,
    _ref$isDisabled = _ref.isDisabled,
    isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? undefined : _ref$id;
  return /*#__PURE__*/React.createElement("button", {
    id: id,
    className: "".concat(stl.btn, " ").concat(className ? className : ""),
    onClick: onClick,
    type: type ? type : null,
    disabled: isDisabled
  }, children);
};
export default Button;